import { apiCall } from './generated/gqlClient';

const getCurrentReservationsApiRequest = async () => {
  const query = `
    query getCurrentReservations {
      getCurrentReservations {
        id
        userId
        providerId
        serviceId
        startTime
        endTime
        userEmail
        fullname
        phone
        serviceName
        serviceDuration
        serviceCapacity
      }
    }
  `;

  return apiCall({ query });
};

const cancelReservationApiRequest = async reservationId => {
  const mutation = `
    mutation cancelReservation($reservationId: Int!) {
      cancelReservation(reservationId: $reservationId) {
        id
        message
        success
      }
    }
  `;
  return apiCall({ query: mutation, variables: { reservationId } });
};

const getReservationPriceApiRequest = async reservationId => {
  const query = `
    query getReservationPrice($reservationId: Int!) {
      getReservationPrice(reservationId: $reservationId) {
        price
      }
    }
  `;
  return apiCall({ query, variables: { reservationId } });
};
const getCustomersSubserviceReservationsApiRequest = async (subserviceId, userId, customerId) => {
  const query = `
    query getCustomersSubserviceReservations($subserviceId: Int!, $userId: Int, $customerId: Int) {
      getCustomersSubserviceReservations(subserviceId: $subserviceId, userId: $userId, customerId: $customerId) {
        future {
          id
          startTime
          endTime
          presence
          subService {
            name
          }
        }
        past {
          id
          startTime
          endTime
          presence
          subService {
            name
          }
        }
      }
    }
  `;
  return apiCall({ query, variables: { subserviceId, userId, customerId } });
};

export { cancelReservationApiRequest, getCurrentReservationsApiRequest, getCustomersSubserviceReservationsApiRequest, getReservationPriceApiRequest };

// "Annulla prenotazioni e iscrizioni" (#1713): every active booking of the period, filtered in
// the modal. Answers { success, data } like every apiCall.
export const getBookingsForMultipleCancelApiRequest = async ({ fromDate, toDate }) =>
  apiCall({
    query: `
    query getBookingsForMultipleCancel($fromDate: String!, $toDate: String!) {
      getBookingsForMultipleCancel(fromDate: $fromDate, toDate: $toDate)
    }`,
    variables: { fromDate, toDate },
  });

// Modifica N (#1713): the per-reservation check before saving, then the save, each answering
// [{ id, status | success, error }]. `requests` are updateReservation's ReservationUpdateInput.
// `moving`: the ids of the batch's other reservations that move too (their current slots don't count).
export const checkMultipleReservationsUpdateApiRequest = async ({ requests, moving }) =>
  apiCall({
    query: `
    query checkMultipleReservationsUpdate($requests: [ReservationUpdateInput]!, $moving: [Int]) {
      checkMultipleReservationsUpdate(requests: $requests, moving: $moving)
    }`,
    variables: { requests, moving: moving || [] },
  });

export const updateMultipleReservationsApiRequest = async ({ requests }) =>
  apiCall({
    query: `
    mutation updateMultipleReservations($requests: [ReservationUpdateInput]!) {
      updateMultipleReservations(requests: $requests)
    }`,
    variables: { requests },
  });

// Modifica N (#1713): the proposals for the changes that are not free, found by the API in one call:
// [{ id, dateTimeFrom }] (null when none). `kept`: the batch's free changes, not to be overlapped.
export const findReservationUpdateTimesApiRequest = async ({ requests, kept, moving }) =>
  apiCall({
    query: `
    query findReservationUpdateTimes($requests: [ReservationUpdateInput]!, $kept: [ReservationUpdateInput], $moving: [Int]) {
      findReservationUpdateTimes(requests: $requests, kept: $kept, moving: $moving)
    }`,
    variables: { requests, kept, moving: moving || [] },
  });

// Duplica (#1713): each copy checked as a new booking, without saving: [{ index, status, error }].
// A copy: { dateTimeFrom ("yyyy-MM-ddTHH:mm:00Z", wall-clock), customerId | customerWalkInId, email, overlapConfirmed }.
export const checkReservationCopiesApiRequest = async ({ reservationId, copies }) =>
  apiCall({
    query: `
    query checkReservationCopies($reservationId: Int!, $copies: [ReservationCopyInput]!) {
      checkReservationCopies(reservationId: $reservationId, copies: $copies)
    }`,
    variables: { reservationId: +reservationId, copies },
  });

// Duplica: the copies created one by one as new bookings: [{ index, success, id, error }].
export const duplicateReservationApiRequest = async ({ reservationId, copies }) =>
  apiCall({
    query: `
    mutation duplicateReservation($reservationId: Int!, $copies: [ReservationCopyInput]!) {
      duplicateReservation(reservationId: $reservationId, copies: $copies)
    }`,
    variables: { reservationId: +reservationId, copies },
  });
